import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function PriceSection() {
  const {
    ref,
    isVisible
  } = useScrollReveal();
  return <section id="offer-section" className="w-full py-14 md:py-24 px-6 relative" style={{
    background: '#111827'
  }} data-id="element-201">
      <div className="max-w-3xl mx-auto text-center" data-id="element-202">
        <div ref={ref} className={`reveal ${isVisible ? 'visible' : ''}`} data-id="element-203">
          {/* Offer Card */}
          <div className="w-full max-w-md mx-auto rounded-2xl px-8 py-10 flex flex-col items-center gap-5" style={{
          background: 'linear-gradient(160deg, #2A3A2E 0%, #1E2E22 100%)',
          border: '1px solid rgba(160, 180, 140, 0.25)',
          boxShadow: '0 8px 32px rgba(0,0,0,0.3)'
        }} data-id="element-204">
            {/* Crossed-out original price */}
            <span className="text-sm font-medium line-through" style={{
            fontFamily: 'DM Sans, sans-serif',
            color: '#A0A090',
            opacity: 0.55
          }} data-id="element-205">
              150 $
            </span>

            {/* Current price */}
            <div className="flex items-end gap-1" data-id="element-206">
              <span className="text-5xl md:text-6xl font-bold leading-none" style={{
              fontFamily: 'Playfair Display, serif',
              color: '#D4A853'
            }} data-id="element-207">
                9,97
              </span>
              <span className="text-2xl font-bold mb-1" style={{
              fontFamily: 'Playfair Display, serif',
              color: '#D4A853'
            }} data-id="element-208">
                $
              </span>
            </div>

            {/* CTA Button */}
            <a href="https://redevenirmoi.com/cart/53294357643632:1" className="cta-pulse w-full inline-flex items-center justify-center gap-2 px-8 py-5 rounded-xl text-base md:text-lg font-bold transition-transform hover:scale-105 active:scale-95" style={{
            background: 'linear-gradient(135deg, #D4A853 0%, #E8C47A 50%, #D4A853 100%)',
            color: '#0D1B2A',
            fontFamily: 'DM Sans, sans-serif',
            textDecoration: 'none'
          }} onClick={() => {
            if (typeof (window as any).fbq === 'function') {
              ;
              (window as any).fbq('track', 'AddToCart', {
                value: 9.97,
                currency: 'CAD',
                content_name: 'Le Signal OFF'
              });
            }
          }} data-id="element-209">
              DÉBLOQUER MON ACCÈS
            </a>

            {/* Checkmarks */}
            <div className="flex flex-col items-center gap-2 text-sm font-medium" style={{
            fontFamily: 'DM Sans, sans-serif',
            color: '#A0B08C'
          }} data-id="element-210">
              <p data-id="element-211">✅ Accès immédiat dès le paiement</p>
              <p data-id="element-212">✅ Guide complet + 2 Bonus inclus</p>
              <p data-id="element-213">✅ Garantie 30 jours ou remboursée</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}